module.exports = __webpack_public_path__ + "img/general_re.375a1eca.svg";